module.exports = __webpack_public_path__ + "img/OOLONG TEA PROJECT.68f007bb.svg";